import * as React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Button,
  Typography,
  TextField,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import type { AxiosError } from 'axios';
import axios from 'axios';

interface CourierOverrideModalProps {
  onClose: () => void;
  open: boolean;
  managerCode: string;
  setManagerCode: React.Dispatch<React.SetStateAction<string>>;
  handleManagerOverride: () => void;
}

const CourierOverrideModal: React.FC<CourierOverrideModalProps> = ({
  onClose, open, managerCode, setManagerCode, handleManagerOverride,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleManagerCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManagerCode(event.target.value);
  };

  const verifyCode = (managerCodeInput: string) => {
    axios.post('/courier/verifyManager', { Barcode: managerCodeInput })
      .then(
        () => {
          handleManagerOverride();
        },
      )
      .catch((e: AxiosError) => {
        enqueueSnackbar(e?.response?.data, { persist: false, variant: 'error' });
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Grid container direction="row-reverse" spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ fontSize: '1rem' }} variant="subtitle1">
              {'DELETING REPAIR'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: '#587B9F', fontWeight: 700 }}>
              {'Manager code is needed due to this repair already having a store repair number'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography display="inline" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.875rem' }} variant="subtitle1">
              {'You have a repair that is on the manifest or already has a repair number that you are trying to delete.'}
              {' A manager code is needed to delete this repair and confirm the repair is not in the box.'}
            </Typography>
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <TextField size="small" fullWidth label="Manager Code" variant="outlined" type="password" value={managerCode} onChange={handleManagerCodeChange} />
          </Grid>
          <Grid item xs={12} />
          <Grid item>
            <Button
              disabled={managerCode.length === 0}
              id="request-override-button"
              color="secondary"
              variant="contained"
              onClick={() => verifyCode(managerCode)}
            >
              {'REQUEST OVERRIDE'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CourierOverrideModal;
